import { render, staticRenderFns } from "./LmDocumentsNewOrEdit-2.vue?vue&type=template&id=60ff3304&scoped=true&"
import script from "./LmDocumentsNewOrEdit-2.vue?vue&type=script&lang=js&"
export * from "./LmDocumentsNewOrEdit-2.vue?vue&type=script&lang=js&"
import style0 from "./LmDocumentsNewOrEdit-2.vue?vue&type=style&index=0&id=60ff3304&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff3304",
  null
  
)

export default component.exports